import { DrawPage } from '../../pages/DrawPage/DrawPage';
import { Route, Routes } from 'react-router-dom';
import { LogoPage } from '../../pages/LogoPage/LogoPage';
import { AppContext } from '../Menu/MenuButton';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteHandler } from './RouterHandler';
import { AssetsPage } from '../../pages/AssetsPage/AssetsPage';
import { OfficePage } from '../../pages/OfficePage/OfficePage';
import { QuizPage } from '../../pages/QuizPage/QuizPage';
import { backButton, swipeBehavior } from '@telegram-apps/sdk';
import { GamePage } from '../../pages/GamePage/GamePage';
import { ActionsPage } from '../../pages/ActionsPage/ActionsPage';
import { ChallengesPage } from '../../pages/ChallengesPage/ChallengesPage';
import { FaqPage } from '../../pages/FaqPage/FaqPage';
import { ConfirmExit } from './ConfirmExit/ConfirmExit';
import { isTelegramPlatform } from '../../platform/platform';

export const AppRoutes = () => {
    const location = useLocation();    
    const [showConfirm, setShowConfirm] = useState(false);

    const back = useCallback(() => {
        window.history.back();
    }, []);

    const showExitConfirmation = useCallback(() => {
        setShowConfirm(true);
    }, []);

    const cancelHandler = useCallback(() => {
        setShowConfirm(false);
    }, []);  

    useEffect(() => {
        if (!isTelegramPlatform()) {
            return;
        }

        if (backButton.mount.isAvailable()) {
            if (!backButton.isMounted()) {
                backButton.mount();
                backButton.show();
            }

            swipeBehavior.mount();
            if (swipeBehavior.isMounted())
                swipeBehavior.disableVertical();
        }
    }, []);

    useEffect(() => {
        if (!isTelegramPlatform()) {
            return;
        }

        if (backButton.isMounted()) {
            backButton.offClick(showExitConfirmation);
            backButton.offClick(back);

            if (location.state?.isFirstPage) {
                backButton.onClick(showExitConfirmation);
            }
            else {                
                backButton.onClick(back);
            }
        }
    }, [location, back, showExitConfirmation]);

    return (
        <RouteHandler>
            <Routes>
                <Route path={`/${AppContext.Office}/*`} element={ <OfficePage /> } />
                <Route path={`/${AppContext.Actions}/*`} element={ <ActionsPage /> } />
                <Route path={`/${AppContext.Draw}/*`} element={ <DrawPage /> } />
                <Route path={`/${AppContext.Assets}/*`} element={ <AssetsPage /> } />
                
                <Route path={`/${AppContext.Quiz}/*`} element={ <QuizPage /> } />
                <Route path={`/${AppContext.Game}/*`} element={ <GamePage /> } />
                <Route path={`/${AppContext.Challenges}/*`} element={ <ChallengesPage /> } />
                <Route path={`/${AppContext.Faq}`} element={ <FaqPage /> } />

                <Route path='/*' element={ <LogoPage /> } />
            </Routes>
            { showConfirm && <ConfirmExit cancelHandler={ cancelHandler } /> }
        </RouteHandler>
    );
}